"use client"

import { type BasketSessionState } from "@/types/centra/basket-session-state"

/**
 * Client-side wrapper. MUST fetch the API route (not call Centra or server-only code
 * directly) — calling the route via fetch is what avoids the soft-404 issue seen when
 * the client reaches Centra-bearing logic any other way. `credentials: "include"` so the
 * `basket_session` cookie is sent. Used as the SWR fetcher in `useSWRBasketSessionState`.
 */
export const getBasketSessionState = async (): Promise<BasketSessionState> => {
    const response = await fetch("/api/centra/basket-session-state", {
        method: "POST",
        credentials: "include"
    })

    if (!response.ok) {
        throw new Error(`basket-session-state request failed: ${response.status}`)
    }

    return response.json() as Promise<BasketSessionState>
}
